import React from 'react';
import {  Modal, Button } from 'semantic-ui-react'
import VideoJSPlayer from '../VideoJSPlayer';
import { autoplayVideoURL } from "../../shared/urls/clientapi";
import { callService, GET } from "../../shared/serviceInvoker";
import ReactGA from 'react-ga';
import { trackEvent } from '../../shared/tracking';

export default class AutoplayVideoJS extends React.Component {

    constructor() {
        super();
        const videoJsOptions = {
            autoplay: false,
            controls: true,
            sources: []
        }

        this.state = { 
            videoJsOptions: videoJsOptions,
            openVideoJSModalStatus: false,
            disableCloseModal: false,
            videoTitle: '',
            src: ''
        }

        this.closeVideoJSModal = this.closeVideoJSModal.bind(this);
        this.videoEndedSuccess = this.videoEndedSuccess.bind(this);
    }

    componentDidMount() {
        if (sessionStorage.getItem('autoplay_launched') === 'false') {
            if (sessionStorage.getItem("contact_id")) {
                let contact_id = sessionStorage.getItem("contact_id");
                callService(
                    GET,
                    autoplayVideoURL.replace('{contact_id}', contact_id),
                    null,
                    response => {
                        let result = response.data.data;
                        if (result.allowAutoplayVideo === true && result.url){
                            const videoJsOptions = {
                                autoplay: true,
                                controls: true,
                                sources: [{
                                src: result.url,
                                type: 'video/mp4'  
                                }]
                            }

                            let disableCloseModal = result.disableCloseModal
                            if (sessionStorage.getItem('isImpersonating') === 'true') {
                                disableCloseModal = false
                            }

                            this.setState({
                                videoJsOptions: videoJsOptions, 
                                openVideoJSModalStatus: true, 
                                disableCloseModal: disableCloseModal, 
                                maxPlayTime: result.currentTime,
                                videoTitle: result.title,
                                src: result.url
                            })   

                            ReactGA.event({
                                category: 'Video Playback',
                                action: 'Modal Open',
                                });
                            trackEvent('Video Playback', 'Modal Open', result.url, '', '/overview');  
                        }
                    },
                    error => {}
                );
            } 
        }
        sessionStorage.setItem("autoplay_launched", 'true');
    }

    videoEndedSuccess(){
        this.setState({disableCloseModal: false});
    }

    closeVideoJSModal(){
        this.refs.videoPlayer.pauseVideoFromParent();
        this.setState({openVideoJSModalStatus: false});

        ReactGA.event({
            category: 'Video Playback',
            action: 'Modal Close',
            });
        trackEvent('Video Playback', 'Modal Close', this.state.src, '', '/overview');  
    }

    render() {
        return (
            <span>
                <Modal open={this.state.openVideoJSModalStatus} dimmer='blurring' size='large' >
                    <Modal.Header>
                        <div className="divLeft14">
                            {this.state.videoTitle}
                            <span className="divRight">
                                <Button disabled={this.state.disableCloseModal} primary onClick={this.closeVideoJSModal} size="tiny">
                                    Close
                                </Button>
                            </span>
                        </div>
                    </Modal.Header>
                    <Modal.Content>          
                        <VideoJSPlayer 
                            { ...this.state.videoJsOptions} 
                            onVideoEnded={this.videoEndedSuccess} 
                            maxPlayTime={this.state.maxPlayTime}
                            ref="videoPlayer"
                        />                                        
                    </Modal.Content>
                </Modal>
            </span>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/AutoplayVideoJS/index.js